import { HistoricalGraphModel } from './../../../../model/historical-graph.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[Historical chart view] get data', props<{ accountId: number, from?: Date, to?: Date }>());
export const ResponseAction = createAction('[Historical chart view] set data', props<{ payload: HistoricalGraphModel }>());

export const SelectFilterAction = createAction('[Historical chart view] select filter', props<{ payload: string }>());

